var axios = require('axios')
var moment = require('moment-timezone')
const urlGetActivePromotions =  process.env.host + '/' + process.env.version + '/product-salesforce-ef/promotions?from={FROM}&to={TO}'
const urlUploadBanner = process.env.url_earning_framework_upload_banner || ''

const DATE_FORMAT = 'YYYY-MM-DD'
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'

axios.getActivePromotions = function (params, success, callBackError) {
  this.get(urlGetActivePromotions
    .replace('{FROM}', moment.utc(params.from, DATE_TIME_FORMAT).format(DATE_TIME_FORMAT))
    .replace('{TO}', moment.utc(params.to, DATE_TIME_FORMAT).format(DATE_TIME_FORMAT)), {
  }).then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

axios.uploadBanner = function (id, params, success, callBackError) {
  this.post(urlUploadBanner, params, {
    headers: {
      'Content-Type': 'multipart/form-data; boundary=SFJEFBannerUploadBoundary',
      'Salesforce-Id': id
    }
  })
  .then(response => {
    success(response)
  }).catch(error => {
    if (error.response && error.response.status === 400 && typeof callBackError !== 'undefined') {
      if (typeof callBackError !== 'undefined') {
        callBackError(error.response.data)
      }
    }
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/assets/api/EarningFramework.js